import {keys, forEach} from 'lodash'

export const updateFormValues = (newValues, form) => {
    const newValuesKeys = keys(newValues);
    forEach(newValuesKeys, (key) => form.change(key, newValues[key]));
};

